export var questionData: any =
[
    {
        question: "Which of these is a good insulator?",
        options:
        [
            {
                label: "Rubber",
                correct: true
            },
            {
                label: "A key"
            },
            {
                label: "A fork"
            }
        ],
        response: "An insulator is a material that doesn't carry an electric current very well. People working on electricity cables use insulating materials – such as industrial rubber gloves – to protect themselves from being electrocuted."
    },
    {
        question: "How many homes does wind power supply energy for in the UK?",
        options:
        [
            {
                label: "More than 8,000"
            },
            {
                label: "More than 800,000"
            },
            {
                label: "More than 8 million",
                correct: true
            }
        ],
        response: "Wind power is generated both onshore (on land) and offshore (at sea) through wind turbines."
    },
    {
        question: "When was the first British electricity pylon built? ",
        options:
        [
            {
                label: "The 1920s",
                correct: true
            },
            {
                label: "The 1940s"
            },
            {
                label: "The 1950s"
            }
        ],
        response: "The first electricity pylon was erected in Falkirk in 1928. There are now more than 88,000 pylons in the UK."
    },
    {
        question: "The UK Government has pledged to cut carbon dioxide (CO2) emissions by what percentage by 2050?",
        options:
        [
            {
                label: "25%"
            },
            {
                label: "50%"
            },
            {
                label: "80%",
                correct: true
            }
        ],
        response: "The Climate Change Act in 2008 committed the UK to cutting carbon dioxide emissions by 80% by 2050."
    },
    {
        question: "Household energy bills are based on the amount of what used over time?",
        options:
        [
            {
                label: "Kilojoules"
            },
            {
                label: "Kilowatt-hours",
                correct: true
            },
            {
                label: "Joules-hours"
            }
        ],
        response: "Kilowatt-hours measure the amount of energy transferred over a period of time. A home's electricity bill is worked out by multiplying the total amount of electrical units used over a period of time (the total number of kWh) by the price per kWh of electricity."
    },
    {
        question: "What unit do we use to measure the amount of heat in an object?",
        options:
        [
            {
                label: "Volts"
            },
            {
                label: "Amps"
            },
            {
                label: "Joules",
                correct: true
            }
        ],
        response: "Joules (J) measure the amount of energy transferred. You can use the following calculation to work out the amount of energy transferred: Energy transferred (J) = Power (Watts) x Time (seconds)."
    },
    {
        question: "When was the National Grid created?",
        options:
        [
            {
                label: "1926",
                correct: true
            },
            {
                label: "1945"
            },
            {
                label: "1967"
            }
        ],
        response: "The National Grid is a network that carries electricity between generators and substations around the country. Before the National Grid was set up, it was really expensive to get electricity, as there was no central network for delivering it to people's homes."
    },
    {
        question: "Which of these is a renewable resource? ",
        options:
        [
            {
                label: "Coal"
            },
            {
                label: "Gas"
            },
            {
                label: "Tidal",
                correct: true
            }
        ],
        response: "A renewable energy source is one that won't run out, like the sun, wind and waves. Electricity can be captured from the movement of tides using water turbines or a special type of dam."
    },
    {
        question: "Which one of these is not a fossil fuel? ",
        options:
        [
            {
                label: "Oil"
            },
            {
                label: "Coal"
            },
            {
                label: "Wood",
                correct: true
            }
        ],
        response: "Oil and coal (like gas) are fossil fuels. Burning fossil fuels releases carbon dioxide into the atmosphere, which contributes to climate change. Burning wood also releases carbon dioxide, but this can be absorbed by planting new trees."
    },
    {
        question: "Who established that heat was a form of energy? ",
        options:
        [
            {
                label: "Mr Joule",
                correct: true
            },
            {
                label: "Mr Joe"
            },
            {
                label: "Mr Joel"
            }
        ],
        response: "James Joule was a famous scientist and inventor who was born in Manchester in 1818. He developed revolutionary ideas on energy and temperature and, as a result of his work showing that heat was a form of energy, the international unit of energy – the Joule – is named after him."
    },
    {
        question: "How many wind farms are there in the UK?",
        options:
        [
            {
                label: "500"
            },
            {
                label: "1,000",
                correct: true
            },
            {
                label: "2,000"
            }
        ],
        response: "A wind farm is the name given to a group of wind turbines based in one location."
    },
    {
        question: "How much electrical stuff do we throw away in the UK each year?",
        options:
        [
            {
                label: "0.5m tonnes"
            },
            {
                label: "1m tonnes "
            },
            {
                label: "2m tonnes",
                correct: true
            }
        ],
        response: "Waste Electrical and Electronic Equipment (otherwise known as WEEE) is anything you don't need that has a plug or needs a battery to operate. WEEE can't be thrown away with the rest of your household rubbish, but has to be recycled separately at your local recycling centre."
    },
    {
        question: "How much of our energy demand comes from heating? ",
        options:
        [
            {
                label: "Half",
                correct: true
            },
            {
                label: "A quarter"
            },
            {
                label: "An eighth"
            }
        ],
        response: "Many homes are too warm; ideally a thermostat (which regulates a home's temperature) should be set between 18 and 21 degrees."
    },
    {
        question: "Using one tonne of recycled paper saves how many trees? ",
        options:
        [
            {
                label: "0"
            },
            {
                label: "12"
            },
            {
                label: "17",
                correct: true
            }
        ],
        response: "70% less energy is also needed to recycle paper and reuse it compared to making it from raw materials."
    },
    {
        question: "Which country consumes the most energy in the world?",
        options:
        [
            {
                label: "The US"
            },
            {
                label: "China",
                correct: true
            },
            {
                label: "Russia"
            }
        ],
        response: "In the UK, the total amount of energy we use only comes to about 7% of the total amount consumed by China... but remember that China is also a much bigger country!"
    },
    {
        question: "Which of these power sources provides the most reliable supply of energy?",
        options:
        [
            {
                label: "Oil"
            },
            {
                label: "Gas"
            },
            {
                label: "Nuclear",
                correct: true
            }
        ],
        response: "Oil and gas are not a renewable source of energy, whereas nuclear power depends on a natural resource that is abundant in many places around the world. Nuclear also produces electricity reliably and is very low carbon."
    },
    {
        question: "Which of these places would be most effective for harnessing solar power?",
        options:
        [
            {
                label: "Paris (France)"
            },
            {
                label: "Barcelona (Spain) "
            },
            {
                label: "Arizona (US)",
                correct: true
            }
        ],
        response: "Arizona is the sunniest place in the world – and solar panels work best when they are placed in direct sunlight."
    },
    {
        question: "Which energy source generates 11% of the UK's electricity?",
        options:
        [
            {
                label: "Wind",
                correct: true
            },
            {
                label: "Solar"
            },
            {
                label: "Hydro"
            }
        ],
        response: "2015 was a record-breaking year for wind power, as onshore and offshore farms provided 11% of the UK's electricity."
    },
    {
        question: "When do historians believe electricity was first discovered?",
        options:
        [
            {
                label: "600 BC",
                correct: true
            },
            {
                label: "1400"
            },
            {
                label: "1800"
            }
        ],
        response: "600 BC is the date that historians believe electricity was discovered. They attribute this discovery to mathematician Thales of Miletus who apparently realised that polishing a piece of amber with wool created a static charge, which attracted objects like feathers."
    },
    {
        question: "When did the first TV set go on sale in the UK?",
        options:
        [
            {
                label: "1910"
            },
            {
                label: "1928",
                correct: true
            },
            {
                label: "1951"
            }
        ],
        response: "The Model B Televisor – the first TV set – was produced by Scottish inventor John Logie Baird. Three years earlier, he had broadcast the first moving images in a demonstration at London department store, Selfridges."
    },
    {
        question: "In an uninsulated house, what percentage of heat is lost through the roof?",
        options:
        [
            {
                label: "10%"
            },
            {
                label: "20%"
            },
            {
                label: "25%",
                correct: true
            }
        ],
        response: "Homes can be insulated with a variety of materials. One of the most common insulation materials comes from recycled bottles!"
    },
    {
        question: "If everyone in your family spent one minute less in the shower every day, how much could you save per person over a year?",
        options:
        [
            {
                label: "£5"
            },
            {
                label: "£10",
                correct: true
            },
            {
                label: "£20"
            }
        ],
        response: "Most families spend up to a fifth of their heating bill on warming up the water for showers, baths and taps. As well as using less water, your family could save money by installing water-saving products."
    },
    {
        question: "Which country generates the most nuclear power in the world?",
        options:
        [
            {
                label: "The US",
                correct: true
            },
            {
                label: "France"
            },
            {
                label: "Korea"
            }
        ],
        response: "As of 2014, the US produced nearly a third of the world's nuclear power. France produced just over 17% and the UK 2.5%."
    },
    {
        question: "The new nuclear power station being built at Hinkley Point C will provide how much of the UK's electricity in the future?",
        options:
        [
            {
                label: "2%"
            },
            {
                label: "5%"
            },
            {
                label: "7%",
                correct: true
            }
        ],
        response: "Hinkley Point C is the first nuclear power station to have been built in more than 25 years in the UK. It will begin supplying electricity in 2025."
    },
    {
        question: "What percentage of the global population lacks access to electricity?",
        options:
        [
            {
                label: "5%"
            },
            {
                label: "17%",
                correct: true
            },
            {
                label: "32%"
            }
        ],
        response: "1.2 billion people around the world don't have access to electricity. More than 95% of these people are either in sub-Saharan African or developing Asia, and around 80% are in rural areas."
    },
    {
        question: "The first offshore wind farm began operating in what year?",
        options:
        [
            {
                label: "2001",
                correct: true
            },
            {
                label: "2007"
            },
            {
                label: "2015"
            }
        ],
        response: "The UK is the windiest country in Europe and has over 6,900 wind turbines."
    },
    {
        question: "The first electric car was invented in what year?",
        options:
        [
            {
                label: "1881",
                correct: true
            },
            {
                label: "1997"
            },
            {
                label: "2012"
            }
        ],
        response: "The first ever commercially available car with rechargeable batteries was introduced in 1881. But by the end of the First World War, petrol cars had become more reliable and petrol was more available, so the electric car died out. In 1997, the world's first mass-produced hybrid electric vehicle came out in 1997 in Japan, called the Toyota Prius."
    },
    {
        question: "Coal is made from what?",
        options:
        [
            {
                label: "Fossils of plants and trees",
                correct: true
            },
            {
                label: "Fossils from dinosaurs"
            },
            {
                label: "Fossils from fish and other ocean creatures"
            }
        ],
        response: "Coal contains energy that plants absorbed from the sun millions of years ago."
    }
];


// WEBPACK FOOTER //
// ./src/ts/data/Questions.ts